<template>
  <div>
    <div class="bg-black fixed w-full z-50 text-[18px]">
      <nav
        class="px-[5%] my-3 mx-auto md:flex md:justify-between md:items-center"
      >
        <div class="flex mb-3 mr-3 items-center justify-between">
          <router-link to="/">
            <!-- <img src="../../../assets/SVGs/dKiloW.svg" /> -->
            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="83.6"
                            height="44.857"
                            viewBox="0 0 83.6 44.857"
                        >
                            <g
                                id="dkilo_logo"
                                data-name="dkilo logo"
                                transform="translate(-40 -31.124)"
                            >
                                <g
                                    id="white_dkilo_logo"
                                    data-name="white dkilo logo"
                                    transform="translate(40 31.124)"
                                >
                                    <g id="c">
                                        <g id="Group_15925" data-name="Group 15925">
                                            <g
                                                id="Group_15922"
                                                data-name="Group 15922"
                                                transform="translate(25.466 5.216)"
                                            >
                                                <g
                                                    id="Group_15921"
                                                    data-name="Group 15921"
                                                    transform="translate(19.472 4.583)"
                                                >
                                                    <rect
                                                        id="Rectangle_1838"
                                                        data-name="Rectangle 1838"
                                                        width="5.216"
                                                        height="5.216"
                                                        transform="translate(5.216) rotate(90)"
                                                        fill="#fff"
                                                    />
                                                    <path
                                                        id="Path_25624"
                                                        data-name="Path 25624"
                                                        d="M182.8,85.83v22.484H177.61V85.83Z"
                                                        transform="translate(-177.597 -73.907)"
                                                        fill="#fff"
                                                    />
                                                </g>
                                                <path
                                                    id="Path_25625"
                                                    data-name="Path 25625"
                                                    d="M213.633,20.61V59.6H208.44V20.61Z"
                                                    transform="translate(-181.152 -20.61)"
                                                    fill="#fff"
                                                />
                                                <path
                                                    id="Path_25626"
                                                    data-name="Path 25626"
                                                    d="M235.55,95.065a11.177,11.177,0,0,1,3.485-8.289,12.3,12.3,0,0,1,17.038.023,12.041,12.041,0,0,1-.023,16.921,11.91,11.91,0,0,1-8.61,3.394,11.381,11.381,0,0,1-8.473-3.462,11.645,11.645,0,0,1-3.417-8.587Zm5.31.091a7.586,7.586,0,0,0,1.8,5.333,7,7,0,0,0,9.744.023,8.44,8.44,0,0,0,0-10.483,6.341,6.341,0,0,0-4.872-1.984,6.233,6.233,0,0,0-4.824,1.984,7.22,7.22,0,0,0-1.848,5.125Z"
                                                    transform="translate(-201.401 -67.479)"
                                                    fill="#fff"
                                                />
                                                <path
                                                    id="Path_25627"
                                                    data-name="Path 25627"
                                                    d="M110.339,46.556l9.764-9.443H113.13l-7.317,7.271V20.61h-2.584v2.609H100.62V59.6h5.193V50.942l.833-.83,7.433,9.488h6.742l-10.48-13.044Z"
                                                    transform="translate(-100.62 -20.61)"
                                                    fill="#fff"
                                                />
                                            </g>
                                            <g id="Group_15924" data-name="Group 15924">
                                                <g
                                                    id="Group_15923"
                                                    data-name="Group 15923"
                                                    transform="translate(0 2.609)"
                                                >
                                                    <path
                                                        id="Path_25628"
                                                        data-name="Path 25628"
                                                        d="M17.638,23.219V39.726a9.71,9.71,0,0,0-14.611.162A12.1,12.1,0,0,0,0,48.29a12.674,12.674,0,0,0,3.024,8.59,9.889,9.889,0,0,0,7.663,3.371,9.689,9.689,0,0,0,6.95-3V59.6h5.219V25.826H20.247V23.217H17.638Zm-1.453,30.4a5.964,5.964,0,0,1-4.664,1.987,5.68,5.68,0,0,1-4.48-2.055A7.836,7.836,0,0,1,5.31,48.29a7.489,7.489,0,0,1,1.779-5.079,5.74,5.74,0,0,1,4.48-2.03,5.868,5.868,0,0,1,4.616,2.01,7.687,7.687,0,0,1,1.777,5.216,7.694,7.694,0,0,1-1.777,5.219ZM22.856,20.61H20.247v2.609h2.609Z"
                                                        transform="translate(0 -18.003)"
                                                        fill="#369da3"
                                                    />
                                                    <rect
                                                        id="Rectangle_1839"
                                                        data-name="Rectangle 1839"
                                                        width="2.609"
                                                        height="2.609"
                                                        transform="translate(17.638)"
                                                        fill="#369da3"
                                                    />
                                                    <rect
                                                        id="Rectangle_1840"
                                                        data-name="Rectangle 1840"
                                                        width="2.609"
                                                        height="2.609"
                                                        transform="translate(22.856)"
                                                        fill="#369da3"
                                                    />
                                                </g>
                                                <rect
                                                    id="Rectangle_1841"
                                                    data-name="Rectangle 1841"
                                                    width="2.609"
                                                    height="2.609"
                                                    transform="translate(28.075)"
                                                    fill="#369da3"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </router-link>  
                    <!-- Mobile menu button -->
                    <div @click="showMenu = !showMenu" class="flex md:hidden">
                        <button type="button" class="text-white focus:outline-none">
                            <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
                                <path
                                    fill-rule="evenodd"
                                    d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
                <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
                <ul
                    :class="showMenu ? 'flex' : 'hidden'"
                    class="flex-col mt-8 space-y-4 md:flex md:space-y-0 md:flex-row md:items-center md:space-x-8 md:mt-0 xl:space-x-12 cl:mr-[18%]"
                >
                    <router-link to="/" @click="showMenu = !showMenu">
                        <li
                            class="block py-2 pr-4 pl-3 text-white opacity-90 md:p-0 text-[18px] font-normal"
                            :class="[$route.path == '/' ? '  text-secondary' : '']"
                        >
                            Dashboard
                        </li></router-link
                    >
                    <router-link to="/campaigns" @click="showMenu = !showMenu">
                        <li
                            class="block py-2 pr-4 pl-3 text-white opacity-90 md:p-0 text-[18px] font-normal"
                            :class="[
                                $route.path == '/campaigns' || $route.path == '/add-campaign'
                                    ? '  text-secondary'
                                    : '',
                            ]"
                        >
                            Campaigns
                        </li></router-link
                    >
                    <router-link to="/reports" @click="showMenu = !showMenu">
                        <li
                            class="block py-2 pr-4 pl-3 text-white opacity-90 md:p-0 text-[18px] font-normal"
                            :class="[$route.path == '/reports' ? '  text-secondary' : '']"
                        >
                            Reports
                        </li>
                    </router-link>
                    <router-link v-if="tracker == 1 || tracker == 2" to="/tracking" @click="showMenu = !showMenu">
                        <li
                            class="block py-2 pr-4 pl-3 text-white opacity-90 md:p-0 text-[18px] font-normal"
                            :class="[$route.path == '/tracking' ? '  text-secondary' : '']"
                        >
                            Tracking
                        </li>
                    </router-link>
                    <router-link v-if="tracker == 1 || tracker == 2" to="/leaderboard" @click="showMenu = !showMenu">
                        <li
                            class="block py-2 pr-4 pl-3 text-white opacity-90 md:p-0 text-[18px] font-normal"
                            :class="[$route.path == '/leaderboard' ? '  text-secondary' : '']"
                        >
                            Leaderboard
                        </li>
                    </router-link>
                    <router-link v-if="tracker == 2" to="/screens" @click="showMenu = !showMenu">
                        <li
                            class="block py-2 pr-15 pl-3 text-white opacity-90 md:p-0 text-[18px] font-normal"
                            :class="[$route.path == '/screens' ? '  text-secondary' : '']"
                        >
                            Screens
                        </li>
                    </router-link>
                    <!-- <router-link to="/content-library" @click="showMenu = !showMenu">
                        <li
                            class="hidden xl:block py-2 pr-4 pl-3 text-white opacity-90 md:p-0 text-[18px] font-normal whitespace-nowrap"
                            :class="[$route.path == '/content-library' ? '  text-secondary' : '']"
                        >
                            Content Library
                        </li>
                    </router-link> -->
                    <router-link to="/support" @click="showMenu = !showMenu" class="flex md:hidden">
                        <li
                            class="block py-2 pr-4 pl-3 text-white md:p-0"
                            :class="[$route.path == '/support' ? '  text-secondary' : '']"
                        >
                            Support
                        </li>
                    </router-link>
                    <router-link to="/Profile" @click="showMenu = !showMenu" class="flex md:hidden">
                        <li
                            class="block py-2 pr-4 pl-3 text-white md:p-0"
                            :class="[$route.path == '/Profile' ? '  text-secondary' : '']"
                        >
                            Profile
                        </li>
                    </router-link>
                    <li
                        @click="
                            logOut();
                            showMenu = !showMenu;
                        "
                        class="block md:hidden py-2 pr-4 pl-3 text-white md:p-0"
                    >
                        Log Out
                    </li>
                </ul>
                <div class="hidden md:flex items-center gap-10 md:order-2">
                    <div class="hidden md:flex items-center gap-1 cursor-pointer">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                        >
                            <g
                                id="support_icon"
                                data-name="support icon"
                                transform="translate(-1026 -30)"
                            >
                                <circle
                                    id="Ellipse_1204"
                                    data-name="Ellipse 1204"
                                    cx="15"
                                    cy="15"
                                    r="15"
                                    transform="translate(1026 30)"
                                    fill="none"
                                />
                                <path
                                    id="headset"
                                    d="M18.437,11.151V9.9a7.9,7.9,0,0,0-15.8,0v1.25a4.389,4.389,0,0,0,1.756,8.406A1.756,1.756,0,0,0,6.147,17.8V12.534a1.756,1.756,0,0,0-1.756-1.756V9.9a6.145,6.145,0,1,1,12.29,0v.878a1.756,1.756,0,0,0-1.756,1.756V17.8H12.292a.878.878,0,0,0,0,1.756h4.389a4.389,4.389,0,0,0,1.756-8.406ZM4.391,17.8h0a2.634,2.634,0,1,1,0-5.267Zm12.29,0V12.534a2.634,2.634,0,1,1,0,5.267Z"
                                    transform="translate(1029.986 34)"
                                    fill="#fff"
                                />
                            </g>
                        </svg>
                        <router-link to="/support">
                            <p class="text-white mb-0 text-[14px]">Support</p></router-link
                        >
                    </div>

          <!-- <div
                        class="relative text-lg w-[95px] h-full md:min-w-[143px] z-50 bg-[#162425] rounded-[10px]"
                    >
                        <button
                            class="flex items-center justify-around px-0 py-1 text-white w-full rounded-lg"
                            @click="isOptionsExpanded = !isOptionsExpanded"
                            @blur="isOptionsExpanded = false"
                        >
                            <div
                                class="w-[40px] h-[40px] bg-white rounded-full mr-[1px] flex justify-center items-center"
                            >
                                <img
                                    v-if="previewImage"
                                    :src="previewImage"
                                    class="w-full h-full rounded-full"
                                    alt=""
                                />
                                <svg
                                    v-else
                                    class="flex items-center justify-center mx-auto w-[95%] h-[95%]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="35"
                                    height="35"
                                    viewBox="0 0 35 35"
                                >
                                    <g
                                        id="Group_16106"
                                        data-name="Group 16106"
                                        transform="translate(-683 -223)"
                                    >
                                        <circle
                                            id="Ellipse_1210"
                                            data-name="Ellipse 1210"
                                            cx="17.5"
                                            cy="17.5"
                                            r="17.5"
                                            transform="translate(683 223)"
                                            fill="none"
                                            opacity="0.3"
                                        />
                                        <g
                                            id="user_3_"
                                            data-name="user (3)"
                                            transform="translate(690 231)"
                                        >
                                            <path
                                                id="Path_25867"
                                                data-name="Path 25867"
                                                d="M10.9,9.8A4.9,4.9,0,1,0,6,4.9a4.9,4.9,0,0,0,4.9,4.9Zm0-8.167A3.267,3.267,0,1,1,7.633,4.9,3.267,3.267,0,0,1,10.9,1.633Z"
                                                transform="translate(-0.55)"
                                            />
                                            <path
                                                id="Path_25868"
                                                data-name="Path 25868"
                                                d="M10.35,14A7.358,7.358,0,0,0,3,21.35a.817.817,0,1,0,1.633,0,5.717,5.717,0,1,1,11.433,0,.817.817,0,0,0,1.633,0A7.358,7.358,0,0,0,10.35,14Z"
                                                transform="translate(0 -2.567)"
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <span class="hidden md:flex text-[14px] font-[300] capitalize">
                                {{ state.userFirstName }}
                            </span>

                            <svg
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                class="hidden md:flex h-4 w-4 transform transition-transform duration-200 ease-in-out"
                                :class="isOptionsExpanded ? 'rotate-180' : 'rotate-0'"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </button>
                        <transition
                            enter-active-class="transform transition duration-500 ease-custom"
                            enter-class="-translate-y-1/2 scale-y-0 opacity-0"
                            enter-to-class="translate-y-0 scale-y-100 opacity-100"
                            leave-active-class="transform transition duration-300 ease-custom"
                            leave-class="translate-y-0 scale-y-100 opacity-100"
                            leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
                        >
                            <ul
                                v-show="isOptionsExpanded"
                                class="absolute left-0 right-0 bg-white divide-y rounded-lg shadow-lg overflow-hidden"
                            >
                                <li
                                    v-for="(option, index) in options"
                                    :key="index"
                                    class="transition-colors duration-300 hover:bg-gray-200 cursor-pointer my-auto font-[500] w-full h-12 p-2 text-[13px]"
                                    @click="setOption(option)"
                                >
                                    {{ option }}
                                </li>
                            </ul>
                        </transition>
                    </div> -->

                    <div
                        @click="isOptionsExpanded = !isOptionsExpanded"
                        @blur="isOptionsExpanded = false"
                        tabindex="0"
                    >
                        <div class="group relative bg-gray-800 rounded-[10px] px-1 w-full h-full">
                            <div
                                class="flex items-center justify-between px-0 py-1 text-white w-full"
                            >
                                <div
                                    class="w-[60px] h-[40px] bg-white rounded-full mr-[1px] flex justify-center items-center"
                                >
                                    <img
                                        v-if="$store.state.auth.profile_pic"
                                        :src="$store.state.auth.profile_pic"
                                        class="w-full h-full rounded-full object-cover"
                                    />
                                    <svg
                                        v-else
                                        class="flex items-center justify-center mx-auto w-[95%] h-[95%]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="35"
                                        height="35"
                                        viewBox="0 0 35 35"
                                    >
                                        <g
                                            id="Group_16106"
                                            data-name="Group 16106"
                                            transform="translate(-683 -223)"
                                        >
                                            <circle
                                                id="Ellipse_1210"
                                                data-name="Ellipse 1210"
                                                cx="17.5"
                                                cy="17.5"
                                                r="17.5"
                                                transform="translate(683 223)"
                                                fill="none"
                                                opacity="0.3"
                                            />
                                            <g
                                                id="user_3_"
                                                data-name="user (3)"
                                                transform="translate(690 231)"
                                            >
                                                <path
                                                    id="Path_25867"
                                                    data-name="Path 25867"
                                                    d="M10.9,9.8A4.9,4.9,0,1,0,6,4.9a4.9,4.9,0,0,0,4.9,4.9Zm0-8.167A3.267,3.267,0,1,1,7.633,4.9,3.267,3.267,0,0,1,10.9,1.633Z"
                                                    transform="translate(-0.55)"
                                                />
                                                <path
                                                    id="Path_25868"
                                                    data-name="Path 25868"
                                                    d="M10.35,14A7.358,7.358,0,0,0,3,21.35a.817.817,0,1,0,1.633,0,5.717,5.717,0,1,1,11.433,0,.817.817,0,0,0,1.633,0A7.358,7.358,0,0,0,10.35,14Z"
                                                    transform="translate(0 -2.567)"
                                                />
                                            </g>
                                        </g>
                                    </svg> 
                </div>
                <button
                  class="text-white px-3 rounded flex justify-between w-full items-center"
                >
                  <span
                    class="hidden md:flex text-[14px] font-[300] capitalize"
                  >
                    {{ $store.state.profile.userFirstName }}
                  </span>
                  <!-- <img src="../../../assets/SVGs/DDArrow.svg" class="fill-white hidden md:flex h-4 w-4 transform transition-transform duration-200 ease-in-out "
                                        :class="isOptionsExpanded ? 'rotate-180' : 'rotate-0'"/> -->
                  <svg
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="hidden md:flex h-4 w-4 transform transition-transform duration-200 ease-in-out"
                    :class="isOptionsExpanded ? 'rotate-180' : 'rotate-0'"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
              </div>
              <!--:class="isOptionsExpanded ? '' : 'group-focus-within:visible'" group-focus-within:opacity-100 group-focus-within:translate-y-2 -->
              <nav
                v-if="isOptionsExpanded"
                class="bg-white border-gray-800 rounded w-full transition-all absolute left-0 mt-2"
              >
                <ul class="divide-y">
                  <li
                    @click="goToProfile()"
                    class="flex items-center px-3 py-1 rounded-t-[5px] hover:bg-gray-200 cursor-pointer w-full h-full"
                  >
                     <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="17.168"
                                            height="20.593"
                                            viewBox="0 0 17.168 20.593"
                                        >
                                            <g
                                                id="svgexport-7_63_"
                                                data-name="svgexport-7 (63)"
                                                transform="matrix(1, 0.017, -0.017, 1, 0.355, -0.061)"
                                            >
                                                <path
                                                    id="Path_29426"
                                                    data-name="Path 29426"
                                                    d="M91.936,9.808A4.745,4.745,0,0,0,95.4,8.371,4.745,4.745,0,0,0,96.84,4.9,4.746,4.746,0,0,0,95.4,1.437a4.9,4.9,0,0,0-6.935,0A4.745,4.745,0,0,0,87.032,4.9a4.745,4.745,0,0,0,1.437,3.467A4.747,4.747,0,0,0,91.936,9.808ZM89.312,2.28a3.71,3.71,0,0,1,5.247,0A3.545,3.545,0,0,1,95.647,4.9a3.545,3.545,0,0,1-1.087,2.624,3.709,3.709,0,0,1-5.247,0A3.545,3.545,0,0,1,88.225,4.9,3.545,3.545,0,0,1,89.312,2.28Zm0,0"
                                                    transform="translate(-83.571)"
                                                />
                                                <path
                                                    id="Path_29427"
                                                    data-name="Path 29427"
                                                    d="M16.946,253.138a12.112,12.112,0,0,0-.165-1.287,10.137,10.137,0,0,0-.316-1.294,6.39,6.39,0,0,0-.532-1.206,4.548,4.548,0,0,0-.8-1.045,3.535,3.535,0,0,0-1.152-.724,3.981,3.981,0,0,0-1.47-.266,1.493,1.493,0,0,0-.8.338c-.239.156-.518.336-.83.535a4.758,4.758,0,0,1-1.074.473,4.172,4.172,0,0,1-2.628,0,4.744,4.744,0,0,1-1.074-.473c-.309-.2-.589-.378-.831-.536a1.491,1.491,0,0,0-.8-.338,3.976,3.976,0,0,0-1.47.266,3.532,3.532,0,0,0-1.152.724,4.548,4.548,0,0,0-.8,1.045,6.4,6.4,0,0,0-.532,1.206,10.161,10.161,0,0,0-.316,1.293,12.03,12.03,0,0,0-.165,1.287c-.027.389-.041.793-.041,1.2A3.381,3.381,0,0,0,1,256.9a3.614,3.614,0,0,0,2.587.944h9.8a3.615,3.615,0,0,0,2.587-.944,3.38,3.38,0,0,0,1-2.558c0-.41-.014-.815-.041-1.2Zm-1.786,2.9a2.434,2.434,0,0,1-1.765.615h-9.8a2.434,2.434,0,0,1-1.765-.615,2.208,2.208,0,0,1-.634-1.693c0-.382.013-.758.038-1.12a10.851,10.851,0,0,1,.149-1.159,8.962,8.962,0,0,1,.278-1.14,5.211,5.211,0,0,1,.433-.981,3.372,3.372,0,0,1,.589-.772,2.345,2.345,0,0,1,.766-.476,2.746,2.746,0,0,1,.94-.181c.042.022.116.065.237.143.245.16.528.342.841.542a5.912,5.912,0,0,0,1.348.6,5.364,5.364,0,0,0,3.362,0,5.919,5.919,0,0,0,1.349-.6c.32-.2.595-.382.84-.542.121-.078.195-.121.237-.143a2.748,2.748,0,0,1,.94.181,2.349,2.349,0,0,1,.766.476,3.362,3.362,0,0,1,.589.772,5.194,5.194,0,0,1,.433.981,8.94,8.94,0,0,1,.278,1.14,10.942,10.942,0,0,1,.149,1.159h0c.025.36.038.737.038,1.119a2.207,2.207,0,0,1-.634,1.693Zm0,0"
                                                    transform="translate(0 -237.481)"
                                                />
                                            </g>
                                        </svg>

                                        <span class="block px-4 py-2 text-[16px]"> Profile</span>
                                        <!-- <router-link
                                            to="/profile"
                                            class="block px-4 py-2 hover:bg-gray-100"
                                            >Profile</router-link
                                        > -->
                                    </li>
                                    <li
                                        class="flex items-center px-3 py-1 rounded-b-[5px] hover:bg-gray-200 cursor-pointer"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="21.337"
                                            height="21.336"
                                            viewBox="0 0 21.337 21.336"
                                        >
                                            <g
                                                id="svgexport-7_64_"
                                                data-name="svgexport-7 (64)"
                                                transform="translate(0 -0.008)"
                                            >
                                                <path
                                                    id="Path_29428"
                                                    data-name="Path 29428"
                                                    d="M286.444,209.341H278a.667.667,0,0,1,0-1.333h8.446a.667.667,0,0,1,0,1.333Zm0,0"
                                                    transform="translate(-265.775 -199.332)"
                                                />
                                                <path
                                                    id="Path_29429"
                                                    data-name="Path 29429"
                                                    d="M400.671,135.973a.667.667,0,0,1-.471-1.139l2.863-2.862-2.863-2.863a.667.667,0,1,1,.943-.943l3.334,3.334a.667.667,0,0,1,0,.943l-3.334,3.334a.662.662,0,0,1-.472.2Zm0,0"
                                                    transform="translate(-383.335 -122.63)"
                                                />
                                                <path
                                                    id="Path_29430"
                                                    data-name="Path 29430"
                                                    d="M7.112,21.344a1.832,1.832,0,0,1-.551-.083L1.21,19.479A1.794,1.794,0,0,1,0,17.788v-16A1.78,1.78,0,0,1,1.778.008a1.834,1.834,0,0,1,.551.083l5.35,1.782A1.794,1.794,0,0,1,8.89,3.564v16a1.78,1.78,0,0,1-1.778,1.778Zm-5.334-20a.446.446,0,0,0-.445.445v16a.462.462,0,0,0,.308.428l5.325,1.774a.483.483,0,0,0,.145.02.446.446,0,0,0,.444-.445v-16a.462.462,0,0,0-.308-.428L1.923,1.361a.483.483,0,0,0-.145-.02Zm0,0"
                                                    transform="translate(0 0)"
                                                />
                                                <path
                                                    id="Path_29431"
                                                    data-name="Path 29431"
                                                    d="M39.114,7.12a.667.667,0,0,1-.667-.667v-4a1.113,1.113,0,0,0-1.111-1.111h-10a.667.667,0,1,1,0-1.333h10a2.447,2.447,0,0,1,2.445,2.445v4A.667.667,0,0,1,39.114,7.12Zm0,0"
                                                    transform="translate(-25.557)"
                                                />
                                                <path
                                                    id="Path_29432"
                                                    data-name="Path 29432"
                                                    d="M185.555,284.452H182a.667.667,0,0,1,0-1.333h3.556a1.113,1.113,0,0,0,1.111-1.111v-4a.667.667,0,0,1,1.333,0v4A2.447,2.447,0,0,1,185.555,284.452Zm0,0"
                                                    transform="translate(-173.776 -265.775)"
                                                />
                                            </g>
                                        </svg>

                    <span class="block px-3 py-2 text-[16px]" @click="logOut()">
                      Log Out</span
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../../../router/router";
import store from "../../../store";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showMenu: false,
      user: "",
      isOptionsExpanded: false,
      previewImage: null,
      // selectedOption: "Profile",
      options: ["Profile", "Log out"],
    };
  },
  async mounted() {
    // this.getUserData();
    await store.dispatch("me");
    // this.previewImage = this.$store.state.auth.profile_pic;
  },
  methods: {
    // async getUserData() {
    //     let token = localStorage.getItem("token");
    //     let apiUrl = "http://publish.test.dkilo.net/api/me";
    //     const res = await axios.get(apiUrl, {
    //         headers: { token: token },
    //     });
    //     this.previewImage = res.data.profile_picture;
    // },
    goTo() {
      router.push("/support");
    },
    // setOption(option) {
    //     this.isOptionsExpanded = false;
    //     if (option == "Profile") {
    //         router.push("/Profile");
    //         console.log("profile");
    //     } else if (option == "Log out") {
    //         try {
    //             console.log("log out");
    //             this.$store.dispatch("logout");
    //         } catch (error) {
    //             console.log(error);
    //         }
    //     }
    // },
    goToProfile() {
      router.push("/profile");
      this.isOptionsExpanded == false;
    },
    async logOut() {
      try {
        // store.commit("toggleLoading");
        await this.$store.dispatch("logout");
        this.isOptionsExpanded = false;
        // store.commit("toggleLoading");
      } catch (error) {
        // store.commit("toggleLoading");
      }
    },
  },
  computed: {
    isUser() {
      return localStorage.getItem("user");
    },
    ...mapGetters(["tracker"]),
    // isfirstName() {
    //     return localStorage.getItem("firstName");
    // },
  },
};
</script>

<style></style>
